import { render, staticRenderFns } from "./InpatientRegist.vue?vue&type=template&id=a8838f5c&scoped=true"
import script from "./InpatientRegist.vue?vue&type=script&lang=js"
export * from "./InpatientRegist.vue?vue&type=script&lang=js"
import style0 from "./InpatientRegist.vue?vue&type=style&index=0&id=a8838f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8838f5c",
  null
  
)

export default component.exports